import axiosFetch from './config';
// import axiosFetch from './configStsging';

export const getCountries = async () => {
    let token = localStorage.getItem("token")
    return axiosFetch({
        method: 'GET',
        url: `/countries`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getStateByCountryId = async (countryId) => {
    let token = localStorage.getItem("token")
    return axiosFetch({
        method: "GET",
        url: `/countries/${countryId}/states`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getCityByStateId = async (countryId, stateId) => {
    let token = localStorage.getItem("token")
    return axiosFetch({
        method: "GET",
        url: `/countries/${countryId}/states/${stateId}/cities`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getZipCode = async (countryId, stateId, cityId) => {
    let token = localStorage.getItem("token")
    return axiosFetch({
        method: "GET",
        url: `/countries/${countryId}/states/${stateId}/cities/${cityId}`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}